import Api from '../api';

export const login = (sourceSystem, token) =>
  Api.get(`/auth/login/${sourceSystem}/${encodeURIComponent(token)}`);

export default login;
